// @flow
import {CardText, CardActions} from "material-ui/Card"
import {Link} from "react-router-dom"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import {containers} from "@swarm2/core"
import Button from "material-ui/RaisedButton"
import LoginIcon from "material-ui/svg-icons/action/account-circle"
import LogoutIcon from "material-ui/svg-icons/action/power-settings-new"
import PlayIcon from "material-ui/svg-icons/av/play-arrow"
import * as React from "react"
import RegisterIcon from "material-ui/svg-icons/action/verified-user"

import * as Util from "../common"

const M = Util.intlMessages("view.TitleView")

export function VersionRender({clientVersion, serverVersion}: Object) {
  return (
    <small>
      <a
        style={{color: "inherit"}}
        target="_blank"
        rel="noopener noreferrer"
        href="https://news.warswarms.com/tags/changelog"
      >
        {!serverVersion ? (
          <M id="version" values={{version: clientVersion + "..."}} />
        ) : clientVersion === serverVersion ? (
          <M id="version" values={{version: clientVersion}} />
        ) : (
          <M id="versions" values={{clientVersion, serverVersion}} />
        )}
      </a>
    </small>
  )
}
export function TitleRender(props: Object) {
  const {
    userExists,
    isAllowed,
    displayName,
    isAnonymous,
    onPlayAuthed,
    onPlayUnauthed,
    onLogout,
    clientVersion,
    serverVersion,
  } = props
  // No error-check here - check for field presence instead. Title is tricky; we
  // want the opening screen to load fast, and the usual error-check is too
  // coarse for that.
  const pending = props.isPending ? (
    <div>
      <Util.LoadingSpinner
        title={"Pending: " + JSON.stringify(props.pendingKeys)}
      />
      {/*JSON.stringify(props.pendingKeys)*/}
    </div>
  ) : null
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          {/*Show a loading spinner while loading; "welcome back" if they have a
            name. The title screen is common/important enough that it gets
            incremental loading, with loading-checks throughout the view and
            loaded-stuff filled in ASAP, instead of a top-level loading spinner.
          */}
          <ToolbarTitle
            text={
              pending ? (
                pending
              ) : isAllowed && userExists ? (
                // isAllowed && !userExists is theoretically possible while
                // loading, before a user's created, but normally this'll be
                // created while applying their beta key.
                <M id="welcomeback" values={{displayName}} />
              ) : (
                <M id="welcome" />
              )
            }
          />
        </ToolbarGroup>
      </Toolbar>
      <CardText>
        <p>
          <b>
            <M id="betawarn" />
          </b>
        </p>
        <hr />
        <p>
          <M id="desc1" />
        </p>
        <p>
          <M id="desc2" />
        </p>
        <p>
          <M id="desc3" />
        </p>
      </CardText>
      {pending ? (
        pending
      ) : // Signed in, has a beta-key, and already email-connected
      isAllowed && !isAnonymous ? (
        <div>
          <CardActions>
            <Link to={"/start"}>
              <Button
                primary
                label={<M id="authed.play" />}
                icon={<PlayIcon />}
                onClick={onPlayAuthed}
              />
            </Link>
            <Button
              secondary
              label={<M id="authed.logout" />}
              icon={<LogoutIcon />}
              onClick={onLogout}
            />
          </CardActions>
        </div>
      ) : // Anonymous user; no email connected, but has a beta key
      isAllowed ? (
        <div>
          <CardActions>
            <Link to={"/start"}>
              <Button
                primary
                label={<M id="authed.play" />}
                icon={<PlayIcon />}
                onClick={onPlayAuthed}
              />
            </Link>
            <Link to={"/auth/register"}>
              <Button
                secondary
                label={<M id="authed.register" />}
                icon={<RegisterIcon />}
              />
            </Link>
          </CardActions>
          <CardText>
            <p>
              <M id="authed.register.help" />
            </p>
          </CardText>
        </div>
      ) : (
        // suckers without beta keys
        <div>
          <CardActions>
            {/*<Link to={'/start'}><Button primary disabled label={<M id="unauthed.play" />} icon={<PlayIcon />} onClick={onPlayUnauthed} /></Link>*/}
            <Button
              primary
              disabled
              label={<M id="unauthed.play" />}
              icon={<PlayIcon />}
              onClick={onPlayUnauthed}
            />
            <Link to={"/auth/login"}>
              <Button
                secondary
                label={<M id="unauthed.login" />}
                icon={<LoginIcon />}
              />
            </Link>
          </CardActions>
          <CardText>
            <p>
              <M
                id="betadesc"
                values={{
                  link: (
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.reddit.com/r/warswarms"
                    >
                      /r/warswarms
                    </a>
                  ),
                }}
              />
            </p>
          </CardText>
        </div>
      )}
      <CardText>
        <small>
          <Link style={{color: "inherit"}} to="/privacy">
            <M id="privacy" />
          </Link>
        </small>{" "}
        | <VersionRender {...{clientVersion, serverVersion}} />
      </CardText>
    </div>
  )
}
export default containers.authSignin.Title(Util.DumpProps(TitleRender))



// WEBPACK FOOTER //
// ./src/app/TitleView.js